import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import { isLogin } from '../../../store/externalCalls/api/sessionApi';
import routes, { getRoute } from '../../../routes/route';

const PublicRoute = ({ children, restricted }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.has('isFilter')) {
      params.delete('isFilter');
      navigate(`${location.pathname}${params.toString() ? `?${params.toString()}` : ''}`, {
        replace: true, state: {
          from: location.pathname,
        },
      });
    }
  }, [location, navigate]);

  if (!isLogin() && restricted) {
    return <Navigate to={getRoute(routes.LOGIN)} replace />;
  }

  return children;
};

PublicRoute.propTypes = {
  children: PropTypes.node.isRequired,
  restricted: PropTypes.bool,
};

PublicRoute.defaultProps = {
  restricted: false,
};

export default PublicRoute;